/*
 * Copyright (C) 2015 Minted Inc
 * All Rights Reserved
 *
 * CTAG:METRICS:LOGGING
 */

/*
  UMD header generated via modularize.js at 2015-04-14T23:57:21.186Z
  assumed dependencies: _serverLogger
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:constants': [],
  'minted:base': []
})(this, function (m_module, $, _) {

var M = m_module.M;

M = M || {};

/**
 * Looks for all elements that have been configured with instrumentation
 * info (eg a GA target, action, etc), parses the data, and adds an
 * event handler that will send GA and /track API events.
 *
 * @param instrTarget - string, the GA target type; if undefined, then
 *   target should be specified in html element data attribute
 */
M.createInstrumentedElements = function(instrTarget, $parentEl) {
  var ls = [],
    $eligibleElements;

  if ($parentEl) {
    $eligibleElements = $parentEl.find(
      '.' + M.InstrumentedElement.prototype.CLASS_TAG);
  } else {
    $eligibleElements = $('.' + M.InstrumentedElement.prototype.CLASS_TAG);
  }
  $eligibleElements.each(function() {
    var $this = $(this);
    // Only instrument the element if it has not been
    if (!$this.data('is-instrumented')) {
      // If one element errors out, continue to process the other elements
      try {
        // if target is not provided, then it should be a data field on
        // the element
        if (typeof instrTarget === 'undefined' || instrTarget === null) {
          var categoryFullStr = $this.data('target');
          var categoryDictKey = categoryFullStr.replace(
              M.InstrumentedElement.prototype.CATEGORY_PREFIX, '');
          instrTarget = M.GA.TRACK_EVENT_CATEGORY[categoryDictKey];
        }
        var instrEl = new M.InstrumentedElement($this, instrTarget);
        ls.push(instrEl);
      } catch(err) {
        _serverLogger.warn('tracking call failed');
      }
      // Set flag on the element to show it has been instrumented
      $this.data('is-instrumented', true);
    }
  });
  return ls;
};

/**
 * Wrapper class that represents any elements that have been configured
 * with instrumentation info.
 *
 * @param $el (object) - jQuery element to instrument
 * @param instrTarget (string) - target string for event tracking
 */
M.InstrumentedElement = function($el, instrTarget) {
  this.$el = $el;
  this.eventSpec = this.$el.data(
    M.InstrumentedElement.prototype.DATA_EVENT_SPEC_KEY);
  // Get the variables configured on the elements.
  // These will be parsed to actual GA data values in validate
  this.target = instrTarget;
  this.attrAction = this.$el.data(
    M.InstrumentedElement.prototype.DATA_ACTION_KEY);
  this.attrLabelCallbackFcnName = this.$el.data(
    M.InstrumentedElement.prototype.DATA_LABEL_CALLBACK_KEY);
  this.attrValueCallbackFcnName = this.$el.data(
    M.InstrumentedElement.prototype.DATA_VALUE_CALLBACK_KEY);

  this.extraInfo = this.formatExtraDataAttributes(
    this.getCamelCaseDataAttributes(this.$el)
  );
  this.validateAndSetDataAttributes();
  this.bindEventSpec();
  return this;
};

/**
 * Format instrmentation extrainfo dictionary.
 *
 * @param dataDict - map object
 */
M.InstrumentedElement.prototype.formatExtraDataAttributes = function(dataDict) {
  var extraInfo = {};

  // key in dataDict will be converted to camel-case because of the feature
  // of .data(). e.g. data-instrumented-extrainfo-sku will be converted into
  // instrumentedExtrainfoSku.
  var tmpLength = M.InstrumentedElement.prototype.DATA_EXTRAINFO_KEY_CAMEL.length;
  var startsWithPatt = new RegExp("^" +
    M.InstrumentedElement.prototype.DATA_EXTRAINFO_KEY_CAMEL);
  var camelPatt = new RegExp("^[a-z]+[A-Z]+");

  for (var key in dataDict) {
    if (!startsWithPatt.test(key)) {
      continue;
    }

    var dataKeySubString = key.substring(tmpLength);
    // We consider camelCase dataKeySubString and dataKeySubString with hyphen
    // as invalid input.
    if (dataKeySubString.length !== 0 && !camelPatt.test(dataKeySubString) &&
      dataKeySubString.indexOf('-') === -1) {
      extraInfo[dataKeySubString.toLowerCase()] = encodeURIComponent(dataDict[key]);
    }
  }
  return extraInfo;
};

/**
 * Get data attributes with key name camelCased.
 * @param el - element object
 *
 */
M.InstrumentedElement.prototype.getCamelCaseDataAttributes = function(el) {
  var data = {};
  /* Introduce this function because we have different version jQuery across the
    * web app, and version<1.4.3, data() will not examine html5 data-* attrs. */
  var atLeast = function(current, required) {
    var current = current.split('.');
    var required = required.split('.');
    for (var idx=0; idx<Math.min(current.length, required.length); idx++) {
      if (parseInt(current[idx]) != parseInt(required[idx])) {
        return parseInt(current[idx]) > parseInt(required[idx]);
      }
    }
    return current.length >= required.length;
  }
  if (el.data && typeof el.data === 'function' && atLeast(el.jquery, '1.4.3')) {
    return el.data();
  }
  for (var key in el[0].attributes) {
    var attr = el[0].attributes.item(key);
    if (/^data-/.test(attr.name)) {
      var camelCaseName = attr.name.substr(5).replace(/-(.)/g, function ($0, $1) {
        return $1.toUpperCase();
      });
      data[camelCaseName] = attr.value;
    }
  }
  return data;
}

M.InstrumentedElement.prototype.validateAndSetDataAttributes = function() {
  M.assert(_.contains(
    M.InstrumentedElement.prototype.VALID_EVENT_SPECS, this.eventSpec));
  M.required(this.target);
  M.required(this.attrAction);
  M.assert(_.contains(M.GA.TRACK_EVENT_CATEGORY, this.target));
  M.assert(
    this.attrAction.indexOf(
      M.InstrumentedElement.prototype.ACTION_PREFIX) != -1);

  var actionDictKey = this.attrAction.replace(
    M.InstrumentedElement.prototype.ACTION_PREFIX, '');
  M.assert(actionDictKey in M.GA.TRACK_EVENT_ACTION);
  this.action = M.GA.TRACK_EVENT_ACTION[actionDictKey];

  if (this.attrLabelCallbackFcnName) {
    M.assert(this.attrLabelCallbackFcnName in M.InstrumentedElement.prototype.FUNCTION_CALLBACKS);
    this.labelCallbackFcn = M.InstrumentedElement.prototype.FUNCTION_CALLBACKS[
      this.attrLabelCallbackFcnName];
  }

  if (this.attrValueCallbackFcnName) {
    M.assert(this.attrValueCallbackFcnName in M.InstrumentedElement.prototype.FUNCTION_CALLBACKS);
    M.assert(this.attrLabelCallbackFcnName);
    M.assert(this.attrValueCallbackFcnName != this.attrLabelCallbackFcnName);
    this.valueCallbackFcn = M.InstrumentedElement.prototype.FUNCTION_CALLBACKS[
      this.attrValueCallbackFcnName];
  }
};

function UnknownJqueryVersionException() {
  this.name = 'UnknownJqueryVersionException';
  this.message = 'The version of jquery does not support .on() or .bind()';
}
UnknownJqueryVersionException.prototype = new Error();

M.InstrumentedElement.prototype.bindEventSpec = function() {
  var that = this;

  var trackEvent = function(e) {
    var gaAndTrackData = that.getGaAndTrackData(e);
    M.sendTrackAPIAndGAEvent(gaAndTrackData[0],
      gaAndTrackData[1]);
  };

  // jQuery 1.7+ (most pages)
  if (typeof this.$el.on === 'function') {
    this.$el.on(that.eventSpec, function(e) {
      trackEvent(e);
    });

  // jQuery < 1.7 (Qcodo PDP)
  } else if (typeof this.$el.bind === 'function') {
    this.$el.bind(that.eventSpec, function(e) {
      trackEvent(e);
    });

  // We are using some version of jQuery that does not support bind() or on()
  } else {
    throw new UnknownJqueryVersionException();
  }
};

M.InstrumentedElement.prototype.getGaAndTrackData = function(e) {
  var gaData = {}, trackData = {};
  var that = this;
  gaData['target'] = trackData['feature'] = that.target;
  gaData['action'] = trackData['event'] = that.action;

  if (that.labelCallbackFcn) {
    var labelVal = that.labelCallbackFcn(e.target);
    gaData['label'] = trackData['label'] = labelVal;
  }

  if (that.valueCallbackFcn) {
    var value = that.valueCallbackFcn(e.target);
    gaData['value'] = trackData['value'] = value;
  }

  if (that.extraInfo) {
    for (var key in that.extraInfo) {
      // For avoid having same attribute in instrumented-extrainfo and base
      // data attributes, if we have both, use the one in base data attribute.
      if (!trackData[key]) {
        trackData[key] = that.extraInfo[key];
      }
    }
  }
  return [gaData, trackData];
};

M.InstrumentedElement.prototype.CLASS_TAG = 'instrumentedElement';
M.InstrumentedElement.prototype.CATEGORY_PREFIX = "M.GA.TRACK_EVENT_CATEGORY.";
M.InstrumentedElement.prototype.ACTION_PREFIX = "M.GA.TRACK_EVENT_ACTION.";
M.InstrumentedElement.prototype.VALID_EVENT_SPECS = ['click', 'hover', 'change'];

M.InstrumentedElement.prototype.DATA_EVENT_SPEC_KEY = 'instrumented-eventspec';
M.InstrumentedElement.prototype.DATA_ACTION_KEY = 'action';
M.InstrumentedElement.prototype.DATA_LABEL_CALLBACK_KEY = 'labelcallback';
M.InstrumentedElement.prototype.DATA_VALUE_CALLBACK_KEY = 'valuecallback';

// data- attribute will be converted to be camel-cased based on HTML5.
// refer: http://www.w3.org/TR/html5/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes
M.InstrumentedElement.prototype.DATA_EXTRAINFO_KEY_CAMEL = 'instrumentedExtrainfo';

// Call back functions for passing dynamic values to labels. Add functions
// as needed in order to
M.InstrumentedElement.prototype.FUNCTION_CALLBACKS = {
  LEADERBOARD_SECTION_CALLBACK: function(elem) {
    return $(elem).parents('.leaderboardSection').data('section');
  },
  CLOSEST_TABLE_NAME_CALLBACK: function(elem) {
    return $(elem).closest('table').data('table-name');
  },
  STATIC_VALUE_CALLBACK: function(elem) {
    return $(elem).data('labelvalue').toString();
  },
  VALUE_CALLBACK: function(elem) {
    return $(elem).attr('value');
  },
  TEXT_VALUE_CALLBACK: function(elem) {
    return $(elem).text();
  },
  CHECKBOX_VALUE_CALLBACK: function(elem) {
    return $(elem).is(':checked');
  },
  LINK_VALUE_CALLBACK: function(elem) {
    return $(elem).attr('href');
  },
  SELECTED_OPTION_CALLBACK: function(elem) {
    return $(elem).children('option:selected').text();
  },
  PRODUCT_POSITION_CALLBACK: function(elem) {
    return parseInt($(elem).closest('td').data('product-position'));
  }
};

return {
};

});

